import { Enum_Subsidy_Status } from 'api/graphql-types';
import { StringParam, UrlUpdateType, useQueryParam } from 'use-query-params';

export const STATUS_QUERY_KEY = 'status';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseStatusReturn = {
	status: Enum_Subsidy_Status | null | undefined;
	setStatus: (
		newValue: NewValueType<Enum_Subsidy_Status | string | undefined | null>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useStatus = (): UseStatusReturn => {
	const [status, setStatus] = useQueryParam(STATUS_QUERY_KEY, StringParam);

	return {
		status: status as Enum_Subsidy_Status,
		setStatus
	};
};
